import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import MovingPrice from '../../../components/v2/MovingPrice'
import PromoCodesInput from '../../../components/v2/PromoCodesInput'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Accordion from '../../../components/v2/accordions/Accordion'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import DialogModal from '../../../components/v2/modals/DialogModal'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { currencySymbol, georgianFormatter } from '../../../domain/types'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { AuthState } from '../../../store/authSlice'
import {
  TravelAbroadState,
  setDiscountUsedSuccessfully,
  setInsurerInfo,
  setOfferTotalPrice,
  setPromoCode,
  setPromoCodeUsedSuccessfully,
  setPromoCodeValue,
} from '../../../store/travelAbroadSlice'
import React from 'react'
//
//
const CheckInformation = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const dispatch = useAppDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { screenHeader, filter, checkout } = useAppSelector(
    (data: { travelAbroad: TravelAbroadState }) => data.travelAbroad,
  )
  //
  const { data: productCategories, isLoading: isProductCategoryLoading } =
    api.useGetProductCategoriesListQuery(undefined)
  //
  const categoryId = productCategories?.find((x) => x.slug === 'travel-outside-georgia')?.id || 0
  //
  const { data: informationsheetlist, isLoading: isInformationSheetListLoading } = api.useGetInformationSheetQuery({
    categoryId: categoryId,
    attachmentSlug: 'information-sheet',
  })
  //
  const itemID = informationsheetlist?.find((x) => x.productCategoryId === categoryId)?.id || 0
  //
  const { data: currentInformationSheet, isLoading: isCurrentInformationSheetLoading } =
    api.useGetInformationSheetDetailQuery(itemID, {
      skip: !itemID && true,
    })
  //
  const [franiTersModalIsOpen, setFraniTersModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeFraniTersModal = () => {
    setFraniTersModalIsOpen(false)
  }
  //
  //
  const [inurerCompanuTermsModalIsOpen, setFnurerCompanuTermsModalIsOpen] = useState<boolean>(false)
  //
  //
  const closeInsurerCompanyModal = () => {
    setFnurerCompanuTermsModalIsOpen(false)
  }
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  const [
    travelAbroadDiscount,
    {
      isLoading: isTravelAbroadDiscountLoading,
      data: discountedPrice,
      isError: discountError,
      isSuccess: discountSuccess,
    },
  ] = api.useGetTravelPaymentDiscountMutation()
  //
  //
  const [isOpen] = useState<boolean>(false)
  //
  //
  const CheckboxText =
    t('iReadAndAgree') +
    ' ' +
    filter?.offer?.companyName +
    `${lang === 'ge' ? ' - ს' : "'s"} ` +
    t('insuranceCondition')
  //
  const parsedWordingFileUrl = filter?.offer?.productWording?.includes('translations')
    ? JSON.parse(filter?.offer?.productWording)
    : ''
  //
  const discountCallBack = useCallback(async () => {
    //
    //
    const localSelectedTravel = filter.singleOrMulti?.split('-')[0] // 'single' or 'multi'
    //
    const userChoseCompanies = filter.offer ? [filter.offer.companyId] : []
    //
    // addons
    const attachedAddons = (filter.attachedAddons || []).map((item) => ({
      id: item?.addon?.addonId,
      travelersCount: item?.count,
      groupedId: null,
    }))
    //
    const groupedAttachedAddons = (filter.groupedAttachedAddons || []).map((item) => ({
      id: item?.addon?.addons?.[0]?.addon?.id,
      travelersCount: item?.count,
      groupedId: item?.addon?.id,
    }))
    //
    const combinedAddons = [...attachedAddons, ...groupedAttachedAddons]
    //
    // travelers date by insurer
    const travelersBirthdays =
      checkout?.forWho === 'travel-abroad-policy-registration-for-me-and-other'
        ? checkout.travelers
            ?.map((traveler) =>
              filter.travelersDate?.find((x) => x?.date === (traveler?.dateOfbirth as any)?.split('-')?.[0]),
            )
            ?.map((item) => ({
              age: item?.age,
              birthday: dayjs(item?.dateFormat).format('YYYY-MM-DD'),
            }))
        : filter.travelersDate?.map((t) => ({
            age: t.age,
            birthday: dayjs(t.dateFormat).format('YYYY-MM-DD'),
          }))
    //
    const travelersAge =
      checkout?.forWho === 'travel-abroad-policy-registration-for-me-and-other'
        ? checkout.travelers
            ?.map((traveler) =>
              filter.travelersDate?.find((x) => x?.date === (traveler?.dateOfbirth as any)?.split('-')?.[0]),
            )
            ?.map((item) => (item?.month === null ? item?.age : 0))
        : filter.travelersDate?.map((t) => (t?.month === null ? t?.age : 0))
    //
    if (
      filter.offer &&
      filter.productCategory &&
      filter.chooseMethod &&
      localSelectedTravel &&
      filter.region &&
      filter.currency &&
      filter.limit &&
      filter.travelersDate &&
      filter.promoCode
    ) {
      try {
        //
        await travelAbroadDiscount({
          promoCode: filter.promoCode || '',
          userId: auth.user?.id ? auth.user?.id : null,
          policyStartDate:
            localSelectedTravel === 'multi'
              ? (filter.multiDates?.start as string)
              : (filter.singleDates?.start as string),
          policyEndDate:
            localSelectedTravel === 'multi' ? (filter.multiDates?.end as string) : (filter.singleDates?.end as string),
          betterOffer: filter.betterOffer || false,
          categorySlug: filter.productCategory,
          whoChoseCompany: 'user-choice',
          userChoseCompanies: userChoseCompanies,
          selectedTravel: localSelectedTravel,
          travelMultiDay: localSelectedTravel === 'multi' ? (filter.multiDays?.days as number) : undefined,
          travelDates:
            localSelectedTravel === 'multi'
              ? {
                  start: filter.multiDates?.start as string,
                  end: filter.multiDates?.end as string,
                }
              : {
                  start: filter.singleDates?.start as string,
                  end: filter.singleDates?.end as string,
                },
          travelArea: filter.region,
          selectedPackage: {
            currency: filter.currency,
            limit: filter.limit,
            franchise: undefined,
            id: filter?.offer?.packageId,
          },
          // travelersAge: filter.travelersDate?.map((t) => t.age),
          travelersAge: travelersAge || [],
          selectedCoverages: combinedAddons || [],
          travelersBirthdays: travelersBirthdays || [],
        }).unwrap()
        //
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage, { toastId: 'some-id-here' })
          //
          dispatch(setPromoCode(''))
        } else {
          toast.error(`${t('promoCodeCantbeUsed')}`)
          dispatch(setPromoCode(''))
        }
      }
    }
    //
  }, [
    filter.betterOffer,
    filter.productCategory,
    filter.chooseMethod,
    filter.region,
    filter.currency,
    filter.limit,
    filter.multiDates?.end,
    filter.multiDates?.start,
    filter.multiDays?.days,
    filter.singleOrMulti,
    filter.travelersDate,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.offer,
    filter.promoCode,
    travelAbroadDiscount,
    t,
    auth?.user?.id,
    filter.attachedAddons,
    filter.groupedAttachedAddons,
    checkout.forWho,
    checkout.travelers,
    dispatch,
  ])
  //
  useEffect(() => {
    //
    discountCallBack()
    //
    return () => {}
  }, [discountCallBack])
  //
  useEffect(() => {
    if (discountedPrice !== undefined) {
      dispatch(setDiscountUsedSuccessfully(true))
      dispatch(setPromoCodeUsedSuccessfully(true))
    } else {
      dispatch(setDiscountUsedSuccessfully(false))
      dispatch(setPromoCodeUsedSuccessfully(false))
    }
  }, [discountedPrice, dispatch])
  //
  //
  // attached Addons Calculate the total price
  const atAddonsOnceTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          .filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + parseInt(item.addon.premium, 10) * item.count, 0)
      : 0
  //
  //
  const atAddonsDailyTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator +
              parseInt(item.addon.premium, 10) * (filter.offer?.calculatedPrices?.insurancesDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  // groupe dAttached Addons Addons Calculate the total price
  const groupOnceAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + item.addon.premium * item.count, 0)
      : 0
  //
  //
  const groupDailyAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator + item.addon.premium * (filter.offer?.calculatedPrices?.insurancesDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  const allAddonPrice =
    atAddonsOnceTotalPrice + groupOnceAddonsTotalPrice + atAddonsDailyTotalPrice + groupDailyAddonsTotalPrice
  //
  useEffect(() => {
    //
    const fullPrice =
      filter.discountUsedSuccesfully && discountedPrice
        ? Number(discountedPrice.discounted)
        : georgianFormatter.format((filter.offer?.calculatedPrices?.totalPremium as number) + allAddonPrice)
    //
    if (filter.offer?.calculatedPrices.totalPremium) {
      dispatch(setOfferTotalPrice(fullPrice as number))
    }
    //
    return () => {}
  }, [
    allAddonPrice,
    filter.offer?.calculatedPrices?.totalPremium,
    dispatch,
    discountedPrice,
    filter.discountUsedSuccesfully,
  ])
  //
  const MainLoader =
    isCountriesLoading ||
    isProductCategoryLoading ||
    isInformationSheetListLoading ||
    isCurrentInformationSheetLoading ||
    isTravelAbroadDiscountLoading
  //
  //
  return MainLoader ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('checkInformation')}</title>
        <meta name="description" content={`${t('checkInformation')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* frani terms modal */}
      <DialogModal
        title={`${t('franiConditions')}`}
        isOpen={franiTersModalIsOpen}
        onClose={closeFraniTersModal}
        src={currentInformationSheet?.attachment?.[lang]?.url || ''}
        isPdf={true}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'privacyTerm',
              fieldValue: true,
            }),
          ),
          closeFraniTersModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'privacyTerm',
              fieldValue: false,
            }),
          ),
          closeFraniTersModal(),
        ]}
      />
      {/* frani terms modal */}

      {/* insurance company terms */}
      <DialogModal
        title={CheckboxText}
        isOpen={inurerCompanuTermsModalIsOpen}
        onClose={closeInsurerCompanyModal}
        src={
          filter?.offer?.productWording?.includes('translations')
            ? parsedWordingFileUrl?.translations?.[lang]?.url
            : undefined
        }
        isPdf={true}
        acceptOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'policyTerm',
              fieldValue: true,
            }),
          ),
          closeInsurerCompanyModal(),
        ]}
        //
        declineOnClick={() => [
          dispatch(
            setInsurerInfo({
              fieldName: 'policyTerm',
              fieldValue: false,
            }),
          ),
          closeInsurerCompanyModal(),
        ]}
      />
      {/* insurance company terms */}

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('checkInformation')} />

        <AbroadProgressBar stepName={`${t('verification')}`} />

        <MovingPrice price={filter.offerTotalPrice} />
        {/*  */}
        {/*  */}
        {/*  */}
        {/* BEGIN TRAVELERS INFO */}
        {checkout.forWho && checkout.forWho !== 'travel-abroad-policy-registration-for-me' ? (
          <TravelersBlock>
            {checkout.travelers?.map((traveler, travelerIndex) => {
              return (
                <Accordion
                  key={travelerIndex}
                  isOpen={false}
                  editBtnOnchange={() => {
                    if (checkout.forWho === 'travel-abroad-policy-registration-for-other') {
                      return navigate('/abroad-for-other')
                    }
                    //
                    if (checkout.forWho === 'travel-abroad-policy-registration-for-me-and-other') {
                      return navigate('/abroad-for-me-and-other')
                    }
                  }}
                  editBtnText={t('edit')}
                  title={` ${
                    travelerIndex === 0 && checkout.forWho === 'travel-abroad-policy-registration-for-me-and-other'
                      ? `${t('insurerInformation')}`
                      : `${t('traveller')}`
                  }  ${travelerIndex >= 1 ? travelerIndex + 1 : ''}`}
                >
                  <TextDiv>
                    <LeftText>{t('cityzenship')}</LeftText>
                    <RightText>
                      {countries?.find((x) => x.isoCode === traveler?.cityzenship)?.translations?.[lang]?.name}
                    </RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('passportNumber')}</LeftText>
                    <RightText>{traveler?.passportNumber}</RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('personalNumber')}</LeftText>
                    <RightText>{traveler?.idNumber}</RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('dateOfBirth')}</LeftText>
                    <RightText>{traveler?.dateOfbirth?.toString()?.replace(/\s/g, ' ')?.split('-')[0]}</RightText>
                  </TextDiv>
                  {traveler?.translations?.ge?.firstName && (
                    <TextDiv>
                      <LeftText>{t('nameInGeorgia')}</LeftText>
                      <RightText>{traveler?.translations?.ge?.firstName}</RightText>
                    </TextDiv>
                  )}
                  {traveler?.translations?.ge?.lastName && (
                    <TextDiv>
                      <LeftText>{t('surnameInGeorgia')}</LeftText>
                      <RightText>{traveler?.translations?.ge?.lastName}</RightText>
                    </TextDiv>
                  )}
                  <TextDiv>
                    <LeftText>{t('nameInEnglish')}</LeftText>
                    <RightText>{traveler?.translations?.en?.firstName}</RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('surnameInEnglish')}</LeftText>
                    <RightText>{traveler?.translations?.en?.lastName}</RightText>
                  </TextDiv>
                  <TextDiv>
                    <LeftText>{t('gender')}</LeftText>
                    <RightText>
                      {traveler.gender === 'female' && `${t('female')}`}
                      {traveler.gender === 'male' && `${t('male')}`}
                    </RightText>
                  </TextDiv>
                  {(traveler.addons && traveler.addons.length >= 1) ||
                  (traveler.groupedAddonInfos && traveler.groupedAddonInfos.length >= 1) ? (
                    <>
                      <hr />
                      {traveler?.addons?.map((atAddon, atAddonIndex) => (
                        <TextDiv key={atAddonIndex}>
                          <LeftText>{atAddon.addonTranslations?.[lang]?.title}</LeftText>
                          <RightText>
                            {atAddon.paymentType === 'DAILY'
                              ? parseFloat(atAddon.premium) * (filter.offer?.calculatedPrices?.insurancesDays || 0)
                              : parseFloat(atAddon.premium)}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}

                      {traveler?.groupedAddonInfos?.map((groupAtAddon, groupAtAddonIndex) => (
                        <TextDiv key={groupAtAddonIndex}>
                          <LeftText>{groupAtAddon.translations?.[lang]?.title}</LeftText>
                          <RightText>
                            {groupAtAddon.paymentType === 'DAILY'
                              ? groupAtAddon.premium * (filter.offer?.calculatedPrices?.insurancesDays || 0)
                              : groupAtAddon.premium}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}
                    </>
                  ) : null}
                </Accordion>
              )
            })}
          </TravelersBlock>
        ) : null}
        {/* END TRAVELERS INFO */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/* BEGIN FOR ME & FOR OTHER INFO */}
        {checkout.forWho === 'travel-abroad-policy-registration-for-me' ||
        checkout.forWho === 'travel-abroad-policy-registration-for-other' ? (
          <Block>
            <Accordion
              isOpen={isOpen}
              editBtnOnchange={() => {
                if (checkout.forWho === 'travel-abroad-policy-registration-for-me') {
                  return navigate('/abroad-for-me')
                }
                //
                if (checkout.forWho === 'travel-abroad-policy-registration-for-other') {
                  return navigate('/abroad-insurer')
                }
              }}
              editBtnText={t('edit')}
              title={`${t('yourPersonalInfo')}`}
            >
              <TextDiv>
                <LeftText>{t('cityzenship')}</LeftText>
                <RightText>
                  {countries?.find((x) => x.isoCode === checkout?.insurer?.cityzenship)?.translations?.[lang]?.name}
                </RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('passportNumber')}</LeftText>
                <RightText>{checkout?.insurer?.passportNumber}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('personalNumber')}</LeftText>
                <RightText>{checkout?.insurer?.idNumber}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('dateOfBirth')}</LeftText>
                <RightText>{checkout?.insurer?.dateOfbirth?.toString()?.replace(/\s/g, ' ')}</RightText>
              </TextDiv>

              {checkout?.insurer?.translations?.ge?.firstName && (
                <TextDiv>
                  <LeftText>{t('nameInGeorgia')}</LeftText>
                  <RightText>{checkout?.insurer?.translations?.ge?.firstName}</RightText>
                </TextDiv>
              )}

              {checkout?.insurer?.translations?.ge?.lastName && (
                <TextDiv>
                  <LeftText>{t('surnameInGeorgia')}</LeftText>
                  <RightText>{checkout?.insurer?.translations?.ge?.lastName}</RightText>
                </TextDiv>
              )}

              <TextDiv>
                <LeftText>{t('nameInEnglish')}</LeftText>
                <RightText>{checkout?.insurer?.translations?.en?.firstName}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('surnameInEnglish')}</LeftText>
                <RightText>{checkout?.insurer?.translations?.en?.lastName}</RightText>
              </TextDiv>

              <TextDiv>
                <LeftText>{t('gender')}</LeftText>
                <RightText>
                  {checkout?.insurer.gender === 'female' && `${t('female')}`}
                  {checkout?.insurer.gender === 'male' && `${t('male')}`}
                </RightText>
              </TextDiv>

              {checkout.forWho === 'travel-abroad-policy-registration-for-me' ? (
                <>
                  {(filter.attachedAddons && filter.attachedAddons.length >= 1) ||
                  (filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1) ? (
                    <>
                      <hr />
                      {filter.attachedAddons?.map((atAddon, atAddonIndex) => (
                        <TextDiv key={atAddonIndex}>
                          <LeftText>{atAddon.addon.addonTranslations?.[lang]?.title}</LeftText>
                          <RightText>
                            {atAddon.addon.paymentType === 'DAILY'
                              ? parseFloat(atAddon.addon.premium) *
                                (filter.offer?.calculatedPrices?.insurancesDays || 0)
                              : parseFloat(atAddon.addon.premium)}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}

                      {filter?.groupedAttachedAddons?.map((groupAtAddon, groupAtAddonIndex) => (
                        <TextDiv key={groupAtAddonIndex}>
                          <LeftText>{groupAtAddon.addon.translations?.[lang]?.title}</LeftText>
                          <RightText>
                            {groupAtAddon.addon.paymentType === 'DAILY'
                              ? groupAtAddon.addon.premium * (filter.offer?.calculatedPrices?.insurancesDays || 0)
                              : groupAtAddon.addon.premium}{' '}
                            ₾
                          </RightText>
                        </TextDiv>
                      ))}
                    </>
                  ) : null}
                </>
              ) : null}
            </Accordion>
          </Block>
        ) : null}
        {/* END FOR ME & FOR OTHER INFO */}
        {/*  */}
        {/*  */}
        {/*  */}

        <Block>
          <Accordion
            isOpen={true}
            editBtnOnchange={() => alert('edit btn')}
            editBtnText={t('edit')}
            hideEditBtn={true}
            title={`${t('policyInfo')}`}
            disableEditBtn={true}
          >
            <TextDiv>
              <LeftText>{t('insuranceCompany')}</LeftText>
              <RightText>{filter.offer?.companyName}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('policyType')}</LeftText>
              <RightText>
                {(filter.offer?.calculatedPrices.travelType === 'single' && lang === 'ge' && 'ერთჯერადი') ||
                  (filter.offer?.calculatedPrices.travelType === 'single' && lang === 'en' && 'single') ||
                  (filter.offer?.calculatedPrices.travelType === 'multi' && lang === 'ge' && 'მრავალჯერადი') ||
                  (filter.offer?.calculatedPrices.travelType === 'multi' && lang === 'en' && 'multi')}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('numberOfDays')}</LeftText>
              <RightText>
                {filter.offer?.calculatedPrices.insurancesDays} {t('day')}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('startDate')}</LeftText>
              <RightText>{dayjs(filter.offer?.calculatedPrices.startDate).format('DD  MMMM  YYYY')}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('endDate')}</LeftText>
              <RightText>{dayjs(filter.offer?.calculatedPrices.endDate).format('DD  MMMM  YYYY')}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('travelArea')}</LeftText>
              <RightText>
                {filter.offer?.calculatedPrices.area === 'world'
                  ? `${t('world')}`
                  : filter.offer?.calculatedPrices.area === 'europe'
                  ? `${t('europe')}`
                  : filter.offer?.calculatedPrices.area === 'schengen'
                  ? `${t('schengen')}`
                  : null}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('currency')}</LeftText>
              <RightText>{filter.offer?.calculatedPrices?.compensationCurrency?.toUpperCase()}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('limit')}</LeftText>
              <RightText>
                {filter.offer?.calculatedPrices.compensationLimit?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                {currencySymbol(filter.offer?.calculatedPrices?.compensationCurrency)}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('franchise')}</LeftText>
              <RightText>
                {filter.offer?.calculatedPrices.franchise}{' '}
                {currencySymbol(filter.offer?.calculatedPrices?.compensationCurrency)}
              </RightText>
            </TextDiv>

            <hr />

            <PromoCodesInput
              value={filter?.promoCodeValue || ''}
              onChange={(value) => dispatch(setPromoCodeValue(value))}
              onClick={() => {
                if (!filter.promoCodeUsedSuccessfully) {
                  //
                  dispatch(setPromoCode(filter?.promoCodeValue))
                } else {
                  return [
                    dispatch(setPromoCode('')),
                    dispatch(setPromoCodeValue('')),
                    dispatch(setDiscountUsedSuccessfully(false)),
                    dispatch(setPromoCodeUsedSuccessfully(false)),
                  ]
                }
                //
              }}
              buttonSize="medium"
              discountValue={filter.discountUsedSuccesfully ? Number(discountedPrice?.saving) : 0}
              disabled={filter?.promoCode !== '' && filter.discountUsedSuccesfully ? true : false}
              discountUsedSuccesfully={filter.discountUsedSuccesfully ? true : false}
              currency={'gel'}
            />

            <hr />

            <TextDiv style={{ marginTop: '6px' }}>
              <LeftText style={{ color: `${Colors.primaryBlack}` }}>{t('currentPayment')}</LeftText>
              <PriceInfo>
                {discountedPrice && filter.discountUsedSuccesfully && (
                  <DiscountInfo>{georgianFormatter.format(discountedPrice?.actual)} ₾</DiscountInfo>
                )}

                <PriceText>{filter.offerTotalPrice} ₾</PriceText>
              </PriceInfo>
            </TextDiv>

            <hr />

            <Checkbox
              id="check-information-privacy-terms"
              label={`${t('franiConditions')}`}
              checked={checkout.insurer.privacyTerm || false}
              defaultChecked={checkout.insurer.privacyTerm || false}
              onClick={() => setFraniTersModalIsOpen(true)}
            />

            <hr />

            <Checkbox
              id="check-information-company-terms"
              label={CheckboxText}
              checked={checkout.insurer.policyTerm || false}
              defaultChecked={checkout.insurer.policyTerm || false}
              onClick={() => setFnurerCompanuTermsModalIsOpen(true)}
            />
          </Accordion>
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              navigate(
                checkout.forWho === 'travel-abroad-policy-registration-for-me'
                  ? '/abroad-for-me'
                  : checkout.forWho === 'travel-abroad-policy-registration-for-other'
                  ? '/abroad-insurer'
                  : checkout.forWho === 'travel-abroad-policy-registration-for-me-and-other'
                  ? '/abroad-for-me-and-other'
                  : '',
              )
              //
              //
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={checkout.insurer.policyTerm === true && checkout.insurer.privacyTerm === true ? false : true}
            onClick={() => {
              if (
                filter &&
                filter.promoCodeValue &&
                filter.promoCodeValue.length >= 2 &&
                !discountError &&
                !discountSuccess
              ) {
                toast.info(`${t('pleaseActivatePromoCode')}`)
              } else {
                navigate('/policy-registration')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const PriceText = styled.span`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: 500;
`
const PriceInfo = styled.span`
  color: ${Colors.primaryBlack};
`
//
const DiscountInfo = styled.span`
  font-size: 14px;
  text-decoration: line-through;
  color: ${Colors.nevadaGrey};
  margin-right: 12px;
`
const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div``
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  margin-bottom: 14px;
`
const Block = styled.div`
  max-width: 464px;
  width: 100%;
  margin-inline: auto;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`
const TravelersBlock = styled(Block)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-row-gap: 32px;

  ${Responsive.mobile} {
    grid-row-gap: 24px;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
    width: 100%;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default CheckInformation
